/*
 * Scroll-reveal animations. Sections carrying .animate-section start hidden (.animate--hidden)
 * and receive .animate--shown when they enter the viewport. The sticky add-to-cart bar height is
 * subtracted from the root margin so content hidden behind the bar still animates in.
 */
(function () {
  let observer;

  function stickyOffset() {
    const stickyAtc = document.querySelector('.sticky-atc');
    return 50 + (stickyAtc ? stickyAtc.clientHeight : 0);
  }

  function createObserver() {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('animate--shown');
          entry.target.classList.remove('animate--hidden');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: `0px 0px -${stickyOffset()}px 0px` }
    );
  }

  function observeAll(root = document) {
    root.querySelectorAll('.animate-section').forEach((section) => {
      if (section.classList.contains('animate--shown')) return;
      section.classList.add('animate--hidden');
      observer.observe(section);
    });
  }

  function init() {
    createObserver();
    observeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    const show = (event) => {
      const root = event.target || document;
      root.querySelectorAll?.('.animate-section').forEach((section) => {
        section.classList.add('animate--shown');
        section.classList.remove('animate--hidden');
      });
      if (root.classList?.contains('animate-section')) {
        root.classList.add('animate--shown');
        root.classList.remove('animate--hidden');
      }
    };
    document.addEventListener('shopify:section:load', show);
    document.addEventListener('shopify:section:reorder', show);
  }
})();
